import { SubAPI } from "./SubAPI";

// every method here is reached before login
export class Account extends SubAPI {
    // the answer is the same whether or not the email has an account already
    register(props: { email: string; password: string; firstName: string; lastName: string; inviteToken?: string }) {
        return this.fetcher.post<null>("/api/account/register", props);
    }

    // logs the user in, and answers with the workspace to open
    confirm(props: { token: string; inviteToken?: string }) {
        return this.fetcher.post<{ workspace: number }>("/api/account/confirm", props);
    }

    forgotPassword(props: { email: string }) {
        return this.fetcher.post<null>("/api/account/forgot-password", props);
    }

    resetPassword(props: { token: string; password: string }) {
        return this.fetcher.post<null>("/api/account/reset-password", props);
    }
}
